import { ComponentProps } from "react";

import { Step } from "../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import FormSeriesMedicalStep, { IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import { RadiationFormEvaluator, radiationFormQuestions } from "./ComposedRadiationMedicalQuestions";
import ComposedUseCreateMedicalNonCanContactResult from "./ComposedUseCreateMedicalNonCanContactResult";

const ConfiguredRadiationMedicalStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  FormSeriesMedicalStep({
    ...props,
    nextStep: Step.medicalDiabetic,
    medicalQualificationEvaluator: RadiationFormEvaluator,
    FormQuestions: radiationFormQuestions,
    useCreateNonCandidateContactResult: ComposedUseCreateMedicalNonCanContactResult
  });

const ComposedRadiationMedicalStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredRadiationMedicalStep>
>({
  Component: ConfiguredRadiationMedicalStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSavePatientNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSavePatientNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedRadiationMedicalStep;
